var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StatusChip } from '../../../status-chip/status-chip';
import { renderIcon } from '../../../../utils';
import { RoundIcon } from '../../../round-icon/round-icon';
import Typography from '../../../typography/typography';
import * as stackedListStyles from '../../stacked-list.styles';
import * as styles from './alert-list-item.styles';
export var AlertListItem = function (_a) {
    var _b;
    var item = _a.item, onClickItem = _a.onClickItem;
    return (_jsx("div", __assign({ className: styles.menulistItemContainer, onClick: function () {
            if (!!item.onActionClick)
                item.onActionClick();
            else if (!!onClickItem)
                onClickItem(item);
        } }, { children: _jsxs("div", __assign({ className: styles.contentWrapper }, { children: [_jsxs("div", __assign({ className: stackedListStyles.textRowsWrapper }, { children: [!item.icon && (_jsxs("div", { children: [' ', _jsx(RoundIcon, { icon: "RoundIcon", className: "mr-4" })] })), _jsx("div", __assign({ className: stackedListStyles.paragraphWrapper }, { children: _jsxs("div", { children: [_jsx(Typography, { className: "truncate", type: "body", weight: "bold", color: "textMid", text: item.title }), item.subTitle && (_jsxs("div", __assign({ className: styles.menuSubTitle }, { children: [_jsx("div", { className: styles.getShapeClassByAlertSeverity(item.alertSeverity) }), _jsx(Typography, { className: "truncate pl-1", type: "small", weight: "skinny", color: styles.getColourByAlertSeverity(item.alertSeverity), text: (_b = item.subTitle) !== null && _b !== void 0 ? _b : '' })] })))] }) }))] })), item.chipText && (_jsx(StatusChip, __assign({ backgroundColour: "primary", borderColour: "transparent", textColour: "white", text: item.chipText }, { children: renderIcon(item.chipIcon) }))), _jsx("div", { children: renderIcon('ChevronRightIcon', styles.menuChevron) })] })) })));
};
export default AlertListItem;
//# sourceMappingURL=alert-list-item.js.map